import { orgListContentsUrl } from '../urls';
import refresh from '../refresh';

export async function postOrgListContent(listId, orgId, compId) {
  const data = {
    list: listId,
    org: orgId,
    comp: compId,
  };
  return refresh(async () => {
    const response = await fetch(orgListContentsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}

export async function deleteOrgListContent(listId, orgId, compId) {
  const data = {
    list: listId,
    org: orgId,
    comp: compId,
  };
  return refresh(async () => {
    const response = await fetch(orgListContentsUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
